var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        closeOutside: false,
        titulo: "Termo de compromisso",
        width: 700,
        height: 580
      },
      on: {
        closeModal: function($event) {
          return _vm.$emit("cancelar")
        }
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c(
          "div",
          { staticClass: "modal-body-termo" },
          [
            _c("termo-compromisso"),
            _c(
              "div",
              { staticClass: "termo-aceite" },
              [
                _c(
                  "el-checkbox",
                  {
                    staticClass: "check",
                    model: {
                      value: _vm.isAceito,
                      callback: function($$v) {
                        _vm.isAceito = $$v
                      },
                      expression: "isAceito"
                    }
                  },
                  [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.textoTermoAceite) }
                    })
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn-cancelar",
                attrs: { type: "default" },
                on: {
                  click: function($event) {
                    return _vm.$emit("cancelar")
                  }
                }
              },
              [
                _c("i", { staticClass: "fal fa-times" }),
                _c("span", [_vm._v("  Cancelar")])
              ]
            ),
            _c(
              "el-button",
              {
                attrs: { type: "primary", disabled: !_vm.isAceito },
                on: {
                  click: function($event) {
                    return _vm.$emit("confirmar")
                  }
                }
              },
              [
                _c("i", { staticClass: "fal fa-check" }),
                _c("span", [_vm._v("  Confirmar")])
              ]
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2867ce24", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2867ce24","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/cadastro/TermoCompromissoSicarf.vue
// module id = null
// module chunks = 